var _defs, _path, _rect, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameShowsActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b7312c;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M40,64.09c-13.53,0-24.53-11.01-24.53-24.53v-3.95c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v3.95c0,11.87,9.66,21.53,21.53,21.53s21.54-9.66,21.54-21.53v-3.95c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5v3.95c0,13.53-11.01,24.53-24.54,24.53Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 38.5,
    y: 62.59,
    width: 3,
    height: 7.71
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.27,71.8H23.73c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h32.54c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.63,42.9c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h9.07s0-.03,0-.05v-2.3h-9.07c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h9.07v-2.35h-9.07c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h9.07v-2.3s0-.03,0-.05h-9.07c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h8.8c-1.46-8.86-9.16-15.65-18.43-15.65s-16.97,6.79-18.43,15.65h8.8c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-9.07s0,.03,0,.05v2.3h9.07c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-9.07v2.35h9.07c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-9.07v2.3s0,.03,0,.05h9.07c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5h-8.8c1.46,8.86,9.16,15.65,18.43,15.65s16.97-6.79,18.43-15.65h-8.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameShowsActive);
export default __webpack_public_path__ + "static/media/GameShows-active.1b1e93d415439557de65abf70dbd9e56.svg";
export { ForwardRef as ReactComponent };